import Component from '@glimmer/component';

import { action } from '@ember/object';

export default class ListCartProductComponent extends Component {
  @action
  delCart(category, item) {
    this.args.delCart(category, item, this.args.applicationController);
  }
}
